// FIXPONTOS Decimal-string aritmetika — a KIADÁS-oldal (és minden hasonló) közös rétege.
//
// MIÉRT KÜLÖN az `invoice.ts` `parseDecimal2`-jétől: az a SZÁMLA-számítás szigorú bemenete — dob érvénytelen
// stringre, és nem ismer negatív értéket (számlán nincs), sem tizedes-vesszőt. A kiadás-oldalnak mindhárom
// kell:
//   • NEGATÍV érték — a sztornó/jóváíró bizonylat összege negatív, és az összegzésnek LE kell vonnia;
//   • TIZEDES-VESSZŐ — a magyar billentyűzeten az a természetes elválasztó a beviteli mezőben;
//   • NEM-DOBÓ viselkedés — a mező-szintű hibát a Zod mondja ki a falon; ez a réteg csak ne robbanjon
//     közben (a részösszeg-kiírás nem hibakezelő hely).
//
// A pénz SOHA nem float: minden művelet ×100 skálázott egészen (BigInt) megy.
/**
 * `-1234,56` / `1234.5` / `1234` / `1234.5678` → ×100 skálázott egész. Érvénytelen bemenet → `null` (nem dob).
 *
 * KETTŐNÉL TÖBB TIZEDES NEM HIBA, hanem csonkolandó: a buszról és az ETL-ből jöhet több jegy (a Prisma
 * `Decimal` szerializálása, egy migrált sor, egy külső riport), és a plusz jegyek elhagyása legfeljebb egy
 * fillért mozdít. Korábban az ilyen érték NEM ILLESZKEDETT, tehát `null` lett, a hívók pedig `?? 0n`-nel
 * NULLÁNAK vették — egy `1234.567`-es összeg némán ELTŰNT a havi összegzésből. Ami tényleg ismeretlen
 * (ezres szóköz, vessző ezres-elválasztóként, exponenciális alak), az továbbra is `null`.
 */
export function scaleDecimal(value) {
    const m = /^(-?)(\d+)(?:[.,](\d+))?$/.exec(value.trim());
    if (!m)
        return null;
    const sign = m[1] === '-' ? -1n : 1n;
    return sign * (BigInt(m[2] ?? '0') * 100n + BigInt(((m[3] ?? '') + '00').slice(0, 2)));
}
/** ×100 skálázott egész → Decimal-string, MINDIG két tizedessel (a kiírás így stabil). */
export function unscaleDecimal(scaled) {
    const neg = scaled < 0n;
    const abs = neg ? -scaled : scaled;
    return `${neg ? '-' : ''}${abs / 100n}.${(abs % 100n).toString().padStart(2, '0')}`;
}
/** Decimal-string normalizálása két tizedesre. Érvénytelen bemenet → `0.00`. */
export function normalizeDecimal(value) {
    return unscaleDecimal(scaleDecimal(value) ?? 0n);
}
/** Két Decimal-string összege fixpontosan. Az értelmezhetetlen tag nullának számít. */
export function addDecimals(a, b) {
    return unscaleDecimal((scaleDecimal(a) ?? 0n) + (scaleDecimal(b) ?? 0n));
}
/** Két Decimal-string különbsége fixpontosan. Az értelmezhetetlen tag nullának számít. */
export function subtractDecimals(a, b) {
    return unscaleDecimal((scaleDecimal(a) ?? 0n) - (scaleDecimal(b) ?? 0n));
}
/** Decimal-stringek összege fixpontosan (üres listára `0.00`). */
export function sumDecimals(values) {
    let total = 0n;
    for (const v of values)
        total += scaleDecimal(v) ?? 0n;
    return unscaleDecimal(total);
}
//# sourceMappingURL=decimal.js.map